import React from 'react';
import LevelingRankPicker from './LevelingRankPicker';

export default class Leveling1to300 extends React.PureComponent {
    static minValue = 1;
    static maxValue = 300;

    static describeRank = rank => rank.toString();
    static getDefaultValue = () => [1, 100];

    static marks = {
        1: '1',
        50: '50',
        100: '100',
        150: '150',
        200: '200',
        250: '250',
        300: '300',
    };

    render() {
        const { ...rest } = this.props;

        return (
            <LevelingRankPicker
                {...rest}
                min={Leveling1to300.minValue}
                max={Leveling1to300.maxValue}
                marks={Leveling1to300.marks}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/levelingRankPicker/Leveling1to300.js